/* SORAMI — the sign-in gate on add to bag.

   A cart may only be built by a signed-in customer, so an anonymous visitor
   is sent to the login screen and returned to the page they were on.

   That is ALL this file does now. It used to intercept the submit and run its
   own fetch to /cart/add.js, which is what broke the header count and left the
   drawer showing its empty state on the first open: Horizon's <cart-icon> and
   <cart-drawer-component> only react to the cart event that
   <product-form-component> raises, and a hand-rolled fetch raises nothing they
   listen for. The quick-add forms now use that component, so the right thing
   is to stay out of its way.

   The listener runs in the CAPTURE phase on the document so it can stop the
   submit before the component sees it — but only for a signed-out visitor. */
(function () {
  'use strict';

  function signedIn() {
    return window.SORAMI_SIGNED_IN === true;
  }

  function loginUrl() {
    var base = window.SORAMI_LOGIN_URL || '/account/login';
    var back = window.location.pathname + window.location.search;
    return base + (base.indexOf('?') > -1 ? '&' : '?') + 'return_url=' + encodeURIComponent(back);
  }

  function isAddForm(form) {
    if (!form || form.tagName !== 'FORM') return false;
    var action = form.getAttribute('action') || '';
    return action.indexOf('/cart/add') !== -1;
  }

  document.addEventListener(
    'submit',
    function (e) {
      if (signedIn()) return;
      if (!isAddForm(e.target)) return;
      e.preventDefault();
      e.stopPropagation();
      window.location.href = loginUrl();
    },
    true
  );

  /* A click on the button never reaches the form's submit handler if something
     else swallows it first, so the gate is repeated on the click. */
  document.addEventListener(
    'click',
    function (e) {
      if (signedIn()) return;
      if (!e.target.closest) return;
      var btn = e.target.closest('.sorami-card__cta, .sorami-show__cta');
      if (!btn || btn.tagName !== 'BUTTON') return;
      if (!isAddForm(btn.closest('form'))) return;
      e.preventDefault();
      e.stopPropagation();
      window.location.href = loginUrl();
    },
    true
  );

  /* Open the cart drawer when something is added, so the add has a visible
     result. The drawer only does this when it carries `auto-open`, which is a
     theme setting; setting the attribute here keeps the change inside SORAMI's
     own files rather than in the auto-generated settings file. The drawer
     reads the attribute at the moment the cart event lands, so adding it after
     the element has connected is fine. */
  function armDrawer() {
    var drawer = document.querySelector('cart-drawer-component');
    if (drawer && !drawer.hasAttribute('auto-open')) drawer.setAttribute('auto-open', '');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', armDrawer);
  } else {
    armDrawer();
  }
})();
